export const messages = {
  en: {
    storeInfoManage: {
      title: 'Store Information Management',
      basicInfo: 'Basic Information',
      storeInfo: 'Store Information',
      storeName: 'Store Name',
      storeAddress: 'Store Address',
      contactNumber: 'Contact Number',
      storeType: 'Store Type',
      legalPerson: 'Legal Person',
      nearbyLandmark: 'Nearby Landmark',
      operations: 'Operations',
      edit: 'Edit',
      attributeName: 'Attribute Name',
      attributeValue: 'Attribute Value',
      editStoreInfo: 'Edit Store Information',
      editStoreAttr: 'Edit Store Attribute',
      cancel: 'Cancel',
      save: 'Save',
      required: 'Required',
      xCoordinate: 'X Coordinate',
      yCoordinate: 'Y Coordinate'
    }
  },
  zh: {
    storeInfoManage: {
      title: '商户信息管理',
      basicInfo: '基本信息',
      storeInfo: '商户信息',
      storeName: '商户名称',
      storeAddress: '商户地址',
      contactNumber: '联系电话',
      storeType: '商户类型',
      legalPerson: '企业法人',
      nearbyLandmark: '附近地标',
      operations: '操作',
      edit: '修改',
      attributeName: '属性名',
      attributeValue: '属性值',
      editStoreInfo: '修改商户信息',
      editStoreAttr: '修改商户属性',
      cancel: '取消',
      save: '保存',
      required: '必填',
      xCoordinate: 'x坐标',
      yCoordinate: 'y坐标'
    }
  }
}